import React, { useState } from "react";


const CreateAgent = () => {
  const [checkBox, setCheckBox] = useState(false);


//   {
//     "phone_number": "",
//     "channel_id": "",
//     "sip_user_id": "",
//     "sip_channel_id": "",
//     "allowed_IP": "",
//     "outbount_channel_id": "",
//     "outbound_caller_id": "",
//     "sip_active": false,
//     "call_options": null,
//     "call_mode": null,
//     "agent_call_status": null,
//     "campaign_running": false,
//     "active": false,
//     "useragent": null,
//     "current_campaign": null
// }











  return (
    <div className="bg-white h-screen flex justify-center">
      <div className="w-[40.25rem] space-y-2">
        <input
          type="text"
          id="message"
          name="message"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg mt-[5rem] w-full h-12 p-2.5  "
          placeholder="User Name"
          required
        />
        <input
          type="text"
          id="message"
          name="message"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full h-12 p-2.5  "
          placeholder="Password"
          required
        />
        <div className="relative w-full flex space-x-2">
          <select className="w-full h-12 p-2.5 text-gray-500 bg-white border rounded-md shadow-sm outline-none appearance-none focus:border-black">
            <option></option>
            <option value={1}>1</option>
            <option value={2}>2</option>
          </select>
        </div>
        <input
          type="text"
          id="message"
          name="message"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full h-12 p-2.5  "
          placeholder="Enter DID Number"
          required
        />
        <textarea
          name="options"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full h-10 p-2.5 mt-4   "
        ></textarea>
        <select className="w-full h-12 p-2.5 text-gray-500 bg-white border rounded-md shadow-sm outline-none appearance-none focus:border-black">
          <option></option>
          <option>INCOMING</option>
          <option>OUTGOING</option>
          <option>INCOMING & OUTGOING</option>
        </select>
        <input
          type="text"
          id="message"
          name="message"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg mt-[5rem] w-full h-12 p-2.5 "
          placeholder="Phone Number"
          required
        />
        <button
          className="font-bold text-lg rounded-full w-36 h-12"
          style={{
            backgroundImage:
              "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
            color: "white",
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default CreateAgent;
